// Section 8 and 15: Caretaker. Covers 5 children under 6 (a flat 5 care places per working
// caretaker, so coverage does not depend on strength; D-31). Uncovered under-6s take happiness
// -10 and illness 1.5x; a working parent of one loses 20% output (age contributor).
// Constants: config.jobs.caretaker.
import type { Config } from '../../config';
import { alwaysEligible } from '../../core/content-helpers';
import { defineJob, noModifiers } from '../../core/registry';

export function caretaker(config: Config) {
  const c = config.jobs.caretaker;

  return defineJob({
    id: 'caretaker',
    label: 'Caretaker',
    section: 'S8',
    heavy: false,
    output: { kind: 'service', service: 'careSlots' },
    baseYield: c.covers,
    toolFactor: null,
    toolWear: 0,
    risks: {},
    riskIllness: null,
    requiresBuilding: null,
    minStrength: 0,
    modifierTargets: [],
    modifiers: noModifiers,
    produce: (_ctx, _worker, output) =>
      output > 0 ? [{ kind: 'service', service: 'careSlots', amount: c.covers }] : [],
    eligible: alwaysEligible,
  });
}
